import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { TermConditionsAction } from "./APIs/action/index";

const TermConditions = () => {
  const [loading, setLoading] = useState(true);
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    const getPolicy = async () => {
        setLoading(true);
        const data = await TermConditionsAction();
        setPolicy(data);
        setLoading(false);
    };
    getPolicy();
  }, []);
  if (!policy) return null;

  return (
    <Box sx={{ p: 4, display: 'flex', gap: 2, flexDirection: 'column' }}>
      <Typography variant="h1">Terms & Conditions</Typography>
      {(policy.tnc)
        ? policy.tnc.map((section, idx) => (
            <Box key={idx}>
              <Typography variant="h2">{section.header}</Typography>
              <Typography variant="body1">{section.description}</Typography>
            </Box>
          ))
        : <Typography variant="body1">{policy.tnc}</Typography>
      }
    </Box>
  );
};

export default TermConditions;